import { AccessProvider } from '../../../contexts/accessProvider.tsx';
import { StoresContextProvider } from '../../../contexts/stores/stores.tsx';
import { Role } from '../../../models/enums/role.ts';
import StoresBody from './body.tsx';
import StoresHeader from './header.tsx';

const Stores = () => {
    return (
        <AccessProvider roles={[Role.admin, Role.superAdmin]}>
            <StoresContextProvider>
                <StoresHeader />
                <StoresBody />
            </StoresContextProvider>
        </AccessProvider>
    );
};

export default Stores;
